module.exports = __webpack_public_path__ + "img/image37.3f215d5c.jpg";